import React from 'react';
import MultipleChoices from "../common/MultipleChoices";

const DropdownList = (props:any) => {
  return <MultipleChoices {...props} />
}

export default DropdownList;
